<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="手机">
        <el-input v-model="formInline.usermobile" placeholder="请输入手机"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>

      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="username" label="用户名">
        <template slot-scope="scope">
          <div v-html="scope.row.username"></div>
        </template>
      </el-table-column>
      <el-table-column prop="usermobile" label="用户手机" width="180"></el-table-column>

      <el-table-column prop="value" label="余额" width="180"></el-table-column>

      <el-table-column label="消费详情">
        <template slot-scope="scope">
          <el-button type="text" @click="handleViewHistory(scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="page.currentPage"
      :page-size="page.pageSize" layout="total, prev, pager, next" :total="page.total"></el-pagination>


    <el-dialog :title="'使用记录【'+currentRow.usermobile+'】'" :visible="isDialogShow" :before-close="closeForm" :close-on-click-modal="false"
      :close-on-press-escape="false" width="860px">

      <el-table :data="deposit_use_log_tableData" style="width: 100%">
        <el-table-column prop="createtime" label="时间"  width="180">
          <template slot-scope="scope">
            {{ scope.row.createtime.replace("T"," ") }}
          </template>
        </el-table-column>
        <el-table-column prop="orderid" label="订单号" width="230"></el-table-column>
        <el-table-column prop="orderName" label="订单名称" width="230"></el-table-column>
        <el-table-column prop="type" label="类型" width="80"> 
          <template slot-scope="scope">
            <el-tag
            type="success"
            effect="dark"
            v-if="scope.row.type == 1"
            >消费</el-tag
          >

          <el-tag
            type="default"
            effect="dark"
            v-else-if="scope.row.type == 2"
            >充值</el-tag
          >

          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.type == 3"
            >退款</el-tag
          >
          </template></el-table-column>
        <el-table-column prop="value" label="值" width="100"></el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange_deposit_use_log"
        :current-page.sync="deposit_use_log_page.currentPage" :page-size="deposit_use_log_page.pageSize"
        layout="total, prev, pager, next" :total="deposit_use_log_page.total"></el-pagination>
    </el-dialog>


  </div>
</template>

<script>

export default {
  components: {

  },
  data () {
    return {
      formInline: {
        user: "",
        region: ""
      },
      tableData: null,
      deposit_use_log_tableData: null,
      multipleSelection: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isDialogShow: false,

      deposit_use_log_page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },

      currentRow:{}
    };
  },

  methods: {
    onSearch () {
      let queryModel = {
        usermobile: this.formInline.usermobile,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询余额"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },

    onSearchHistory (usermobile) {
      let queryModel = {
        usermobile,
        pageNum: this.deposit_use_log_page.currentPage,
        pageSize: this.deposit_use_log_page.pageSize
      };
      this.$axios(this.$urlMapping["查询余额记录"], {
        data: queryModel
      }).then(result => {
        this.deposit_use_log_tableData = result.data;
        this.deposit_use_log_page.total = result.totalCount;
        this.deposit_use_log_page.currentPage = result.pageNum;
      });
    },

    handleViewHistory (row) {
      console.log(row)
      this.currentRow=row
      this.deposit_use_log_page.currentPage = 1;
      this.onSearchHistory(row.usermobile)
      this.isDialogShow = true;
    },

    closeForm () {
      this.isDialogShow = false;
    },

    handleCurrentChange (currentPage) {
      this.page.currentPage = currentPage;
      this.onSearch();
    },

    handleCurrentChange_deposit_use_log (currentPage) {
      this.deposit_use_log_page.currentPage = currentPage;
      this.onSearchHistory(this.currentRow.usermobile);
    }
  },
  mounted () {
    this.onSearch();
  }
};
</script>

<style lang="less" scoped></style>